import { NotificationsModal } from 'featureSliced/widgets/Modals/NotificationsModal'
import {
  OpenModalFuncType,
  useOpenModal,
} from 'featureSliced/shared/hooks/useOpenModal'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

export const openNotificationsModal = (
  openModal: OpenModalFuncType,
  t: (value: string, substitutions?: any) => string,
  handleClose: () => void
) => {
  openModal({
    id: 'NOTIFICATIONS_MODAL',
    title: t('common.notifications'),
    onClose: handleClose,
    components: [
      ({ closeThisModal }) => (
        <NotificationsModal
          onDeclineClose={closeThisModal}
          onSuccessClose={closeThisModal}
        />
      ),
    ],
  })
}

export const useOpenNotificationsModal = (handleClose: () => void) => {
  const translations = useTranslations()
  const openModal = useOpenModal()

  return () => openNotificationsModal(openModal, translations, handleClose)
}
